module.exports = __webpack_public_path__ + "static/case-hp-04-d1dceadf14830510cbb49b2737fe0594.jpg";